import { GetPayUpType } from '@orbit/api-types'
import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const useUploadPayUpPicture = () => {
    const queryClient = useQueryClient()

    return useMutation<
        GetPayUpType,
        Error,
        { tripId: string; payUpId: number; file: File }
    >({
        mutationFn: async ({ tripId, payUpId, file }) => {
            const formData = new FormData()
            formData.append('file', file)
            const response = await api.post<GetPayUpType>(
                `/trips/${tripId}/payUps/${payUpId}/picture`,
                formData,
                { headers: { 'Content-Type': 'multipart/form-data' } },
            )
            return response.data
        },
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({ queryKey: queryKeys.payups(variables.tripId) })
            queryClient.invalidateQueries({ queryKey: queryKeys.payup(variables.tripId, variables.payUpId) })
            queryClient.invalidateQueries({ queryKey: queryKeys.files(variables.tripId) })
        },
    })
}
